// extracted by mini-css-extract-plugin
export default {"root":"T61VIX6Db4wXJat0ZbGO"};